import { useCallback } from "react";
import api from "./api";


// Hook base: solo maneja la llamada a la API
export const useDeudoresCBO = () => {
 

     const detectarNoPago = async () => {
    try {
      const { data } = await api.post(
        "/deudores/detectar-regularizacion",
        {},
        
      );
      return data; // ← array de conflictos
    } catch (error) {
      throw (
        error.response?.data?.message ||
        "Error al detectar regularizaciones"
      );
    }
  };

  // ✅ Confirmar regularización (OBLIGATORIO enviar ID)
  const confirmarNoPago = async (no_pago_id) => {
    try {
      const { data } = await api.post(
        "/deudores/confirmar-regularizacion",
        { no_pago_id }, // 🔥 ESTO FALTABA
       
      );
      return data;
    } catch (error) {
      throw (
        error.response?.data?.message ||
        "Error al confirmar regularización"
      );
    }
  };


   const getDeudores = useCallback(async () => {
    try {
      const { data } = await api.get("/registro/deudores");
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener los deudores";
    }
  }, []);
  
   const RegistrarPagoDeudor = async ( id,
  monto_pagado,
  fecha_pago,
  sesiones_pagadas,
  episodios) => {
    try {
      const { data } = await api.post(
        `/deudores/${id}/pago`,
         {
    monto_pagado: Number(monto_pagado),
    fecha_pago: fecha_pago || null,
    sesiones_pagadas: Number(sesiones_pagadas),
    episodios: Number(episodios),
  },
    
      );
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al registrar el pago";
    }
  };

  const CambioPacientePagado = async (id, fecha_pago, episodio) => {
    try {
      const { data } = await api.post(
        `/deudores/marcar-pagado/${id}`,
        { fecha_pago, episodio }, // se envía la fecha
       
      );
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al actualizar paciente";
    }
  };

   const eliminarPagoDeudor = async (id) => {
    try {
      const { data } = await api.delete(`/pagos_deudores/${id}`);
      return data;
    } catch (error) {
      console.error("💥 Error al eliminar egreso:", error);
      throw error.response?.data?.message || "Error al eliminar egreso";
    }
  };

  const SincornizacionPacienteDeudor = async () => {
  try {
    const { data } = await api.post(
      `/sincronizar-deudores`,
      {},  
    );
    return data;
  } catch (error) {
    console.error("Error al sincronizar deudores:", error);
    throw error.response?.data?.message || "Error al sincronizar deudores";
  }
};


const editarPacienteDeudor = async (id, params = {}) => {
    try {
      const { data } = await api.post(`/editarDeudor/${id}`, params);
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al editar el usuario";
    }
  };

  const descargarExcelDeudores = async () => {
  const response = await api.get("/deudores/export/excel", {
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));

  const link = document.createElement("a");
  link.href = url;
  link.download = "deudores.xlsx";
  link.click();

  window.URL.revokeObjectURL(url);
};


  // Obtener deudores recientes
  const getDeudoresRecientes = async () => {
    try {
      const { data } = await api.get("/deudores/recientes");
       
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener deudores recientes";
    }
  };

 const getReporteUltimoMesDeudores = useCallback(async () => {
    try {
      const { data } = await api.get("/deudores/reporte-actual");
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener reporte";
    }
  }, []);

  const getReporteAnteriorDeudores = useCallback(async (mes, anio) => {
  try {
    const { data } = await api.get("/deudores/reporte-por-mes", {
      params: { mes, anio }
    });
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener reporte";
  }
}, []);

const getReporteAnual = useCallback(async (anio = null) => {
  try {
    const { data } = await api.get("/registro/Anual", {
      params: anio ? { anio } : {},
    });

    return data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Error al obtener el reporte anual"
    );
  }
}, []);
  return { getReporteAnual, descargarExcelDeudores, detectarNoPago,  getReporteUltimoMesDeudores,  getReporteAnteriorDeudores, confirmarNoPago, getDeudores, CambioPacientePagado, RegistrarPagoDeudor, eliminarPagoDeudor, SincornizacionPacienteDeudor, editarPacienteDeudor, getDeudoresRecientes };

};
